import { put } from 'redux-saga/effects'
import { displayErrorModal } from 'actions/application'
import strings from 'utils/strings'
import { PtpError } from 'services/vehicles'
import { HANDLED, SKIP } from './constants'

/**
 * Domain handler — PTP (Parameter Transfer Protocol) validation failure.
 *
 * The PTP failure is signalled via a `PtpError` instance thrown by the service
 * layer (`services/vehicles.js`) when the backend returns HTTP 200 with
 * `result.code === PTP_ERROR_CODE` in the response body.
 *
 * This handler shows the PTP-specific error modal instead of the generic one.
 *
 * Usage:
 *   import ptpErrorHandler from 'sagas/errorHandlers/ptpErrorHandler'
 *
 *   apiAction({
 *     ...,
 *     errorHandlers: [ptpErrorHandler],
 *   })
 *
 * @param {Error} err - The caught error. Must be a PtpError instance.
 * @returns {'handled'|'skip'}
 */
export default function* ptpErrorHandler(err) {
  // Dual check: instanceof guards the common case; the .name fallback provides
  // cross-realm resilience (e.g. when the error crosses an iframe/worker boundary
  // where `instanceof` can fail despite being the same logical class).
  if (!(err instanceof PtpError) && err.name !== 'PtpError') {
    return SKIP
  }

  yield put(
    displayErrorModal(strings.reference_parameter_ptp_error, [
      strings.ptp_error_report,
      `${err.code}: ${err.description || err.message}`,
    ])
  )

  return HANDLED
}
